import Plan from 'components/pages/financing-for-companies/items/Plan';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import useCommonData from 'hooks/useCommonData';
import useDragPlans from 'hooks/useDragPlans';
import { QUERY } from 'interfaces/graph';
import { filter, uniq } from 'ramda';
import React from 'react';
import { animated } from 'react-spring';
import { css } from 'twin.macro';
import { isMobileScreen } from 'utils/helper';

const cssCarouselList = css`
  .container {
    margin-bottom: 2.5rem;
    overscroll-behavior-y: contain;
    height: 100%;
    width: 15rem;
    user-select: none;
    position: absolute;
    overflow: hidden;
    top: 0;
		right: 0;
  }

  .wrapper {
    will-change: transform;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .item {
    box-shadow: inset 0 0 0 1px var(--color-main);
    border-radius: 1rem;
    width: 70%;
		margin-top: 11.25rem;
    margin-left: auto;
    margin-right: auto;
  }
`;

const plans = [0,1,2,3];

export default function InstrumentsView() {
	const { t } = useTranslation();
	const { secureFinancing } = useCommonData(QUERY.SECURE_FINANCING_ROWS);
	const { bind, items } = useDragPlans({ length: plans.length });

	if(!secureFinancing) return null;

	const rows = secureFinancing.rows.filter(row => row.category.name);
	const categories = rows.map(row => row.category.name);
	const categoriesList = uniq(categories);

	const isMobile = isMobileScreen();

	return (
		<div css={[ isMobile && cssCarouselList ]} tw="relative text-center flex items-center mt-40 sm:mt-50 2xl:mt-80">
			<div className="w-full relative">
				<h2 className="w-2/3 mx-auto mt-30 sm:mt-10 lg:mt-0 mb-20 sm:mb-30">{t('pageFinancingForCompany.instruments.h2')}<span className="text-green-1 font-normal">_</span></h2>
				<div style={{ maxWidth: '75rem' }} className="flex text-left mx-auto">
					<div className="w-55/100 sm:w-full mt-40 z-20">
						{categoriesList.map(categoryName => {
							const listByCategory = filter(item => item.category.name === categoryName, rows);
							return (
								<div key={categoryName}>
									<p className="ml-05 h-12 mt-12 font-bold">{categoryName}</p>
									{listByCategory.map(item => (
										<p key={item.name} className='h-30 ml-05 flex items-center'>{item.name}</p>
									))}
								</div>
							);
						})}
					</div>

					<div className="hidden sm:flex">
						{/* From ENUM_FIN_FOR_COMP_PLAN elements */}
						{plans.map((index, key) => {
							return (
								<Plan
									key={index}
									rows={rows}
									planNumber={key}
									categoriesList={categoriesList}
									isGreen={!index}
								/>
							);
						})}
					</div>
				</div>
			</div>

			<div className="sm:hidden container z-10">
				{items.map(({ x, display, sc, opacity }, index) => (
					<animated.div {...bind()} className="wrapper" key={x} style={{ display, transform: x.interpolate(x => `translate3d(${x}px,0,0)`) }}>
						<animated.div className="item" style={{ transform: sc.interpolate(s => `scale(${s})`), opacity }}>
							<div className="w-full h-full flex flex-col items-center justify-center">
								<Plan
									key={x}
									rows={rows}
									planNumber={index}
									categoriesList={categoriesList}
									isGreen={!index}
								/>
							</div>
						</animated.div>
					</animated.div>
				))}
			</div>
		</div>
	);
}
